import { Radio, RadioGroup, FormControlLabel } from "@mui/material";
import styles from "./input.module.css";

const RadioInputs = (props) => {
	const {
		quizOptions,
		question,
		field,
		hasError,
		errorMessage,
		extraInfo,
		onLogicChange,
		index,
	} = props;

	const properOptions = quizOptions.map((option) => {
		const optionId = option?.option_id
			? option.option_id
			: quizOptions[1].option_id - 1;

		return {
			...option,
			option_id: optionId,
		};
	});

    // const requiresInput = properOptions.findIndex((option) => option.)

	const handleChange = (e) => {
		const selectedOption = properOptions.find(
			(option) => option.option_id.toString() === e.target.id
		);

		//REMOVE action indicates removing the next_question_id from the list of originally hidden quizzes
		if (selectedOption && selectedOption.next_question_id) {
			onLogicChange({
				action: "REMOVE",
				currentId: selectedOption?.quiz_id,
				targetedId: selectedOption.next_question_id,
			});
		} else {
			properOptions.forEach((option) => {
				if (
					option.next_question_id !== null &&
					option.next_question_id !== selectedOption.next_question_id
				) {
					//ADD action indicates adding the next_question_id back to the list of originally hidden quizzes, for a quiz that is not selected
					onLogicChange({
						action: "ADD",
						currentId: selectedOption?.quiz_id,
						targetedId: option.next_question_id,
					});
				}
			});
		}

		field?.onChange(e);
	};

	return (
		<div
			className={styles.inner_form_label}
			data-testid="radiobox_container"
		>
			<div className="flex mb-1 gap-2">
				<span className="text-center bg-primary text-white py-[2px] px-1 rounded-sm !text-sm mr-2 block h-6">
					{index + 1}
				</span>
				<p data-testid="radiobox_element_question">{question}</p>
			</div>
			<small>{extraInfo}</small>
			<RadioGroup
				{...field}
				style={{ display: "block", width: "100%", marginTop: "24px" }}
				data-testid="radiobox_element_container"
			>
				{quizOptions.map((item) => {
					return (
						<FormControlLabel
							key={item.option_id.toString()}
							value={item.option_id.toString()}
							onChange={handleChange}
							control={<Radio id={item.option_id.toString()} />}
							label={item.option_text}
							className={styles.inner_radio_check}
							style={{
								outline:
									field?.value === item.option_id.toString()
										? "1px solid #BE0303"
										: "",
							}}
							data-testid="radiobox_element_field"
						/>
					);
				})}
			</RadioGroup>
			{hasError && <small className="text-danger">{errorMessage}</small>}
		</div>
	);
};

export default RadioInputs;
